import { AlertDialog } from 'common/components/AlertDialog';
import { Embed } from 'common/components/Embed';

interface IProps {
    open: boolean;
    title?: string;
    onClose(): void;
    src: string;
}

export const VideoPlayerDialog = ({ title, src, open, onClose }: IProps) => (
    <AlertDialog
        fullWidth
        maxWidth="lg"
        open={open}
        title={title}
        onClose={onClose}
    >
        <Embed autoplay src={src} />
    </AlertDialog>
);
